import { lazyLoad } from 'utils/loadable';

export const NthProfileViewPage = lazyLoad(
  () => import('./index'),
  module => module.NthProfileViewPage,
);
